import type { ReactNode } from "react";

interface AvatarProps {
  children: ReactNode;
  className?: string;
}

export const Avatar = ({ children, className = "" }: AvatarProps) => {
  return (
    <div
      className={`relative flex shrink-0 overflow-hidden rounded-full ${className}`}
    >
      {children}
    </div>
  );
};

interface AvatarImageProps {
  src: string;
  alt?: string;
}

export const AvatarImage = ({ src, alt = "" }: AvatarImageProps) => {
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      className="aspect-square h-full w-full object-cover"
    />
  );
};

interface AvatarFallbackProps {
  children: ReactNode;
  className?: string;
}

export const AvatarFallback = ({
  children,
  className = "",
}: AvatarFallbackProps) => {
  return (
    <div
      className={`flex h-full w-full items-center justify-center rounded-full font-medium ${className}`}
    >
      {children}
    </div>
  );
};
